export enum DatePickerPreset {
  LastWeek = "LastWeek",
  ThisWeek = "ThisWeek",
  LastMonth = "LastMonth",
  ThisMonth = "ThisMonth",
  Last28Days = "Last28Days",
  Last7Days = "Last7Days",
}

export interface DateRange {
  start: Date;
  end: Date;
}
